import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    email: false,
    error: null,
    channelLoading: false,
    loginLoading: false,
    playlistLoading: false,
    playlistItemLoading: false,
    logins: [],
    channelResult: {},
    channels: {},
    videoResult: {},
    videos: {},
    playlistResult: {},
    playlists: {},
    playlistItemResult: {},
    playlistsItems: {}
};

const getPrimaryEmail = (logins = []) => {
    if(!logins.length) {
        return false;
    }
    
    return logins[0].email;
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
		case actionTypes.YOUTUBE_LOGIN_LIST_START:
			return updateObject(state, { loginLoading: true });
        case actionTypes.YOUTUBE_LOGIN_LIST_SUCCESS:
            return updateObject(state, { logins: action.logins, loginLoading: false, email: getPrimaryEmail(action.logins) });
        case actionTypes.YOUTUBE_LOGIN_ADD_SUCCESS:
            return updateObject(state, { logins: action.logins, loginLoading: false, email: getPrimaryEmail(action.logins) });
		case actionTypes.YOUTUBE_LOGIN_DELETE_SUCCESS:
            return updateObject(state, { logins: action.logins, loginLoading: false, email: getPrimaryEmail(action.logins) });
        case actionTypes.YOUTUBE_CHANNEL_LIST_START:
			return updateObject(state, { channelLoading: true });
        case actionTypes.YOUTUBE_CHANNEL_LIST_SUCCESS:
            const channels = {};
            if(action.result.items) {
                action.result.items.forEach(item => {
                    channels[item.id] = item;
                });
            } 
            return updateObject(state, { channelResult: action.result, channels: channels, channelLoading: false });
        case actionTypes.YOUTUBE_CHANNEL_LIST_FAIL:
			return updateObject(state, { channelLoading: false });
        case actionTypes.YOUTUBE_PLAYLIST_LIST_START:
			return updateObject(state, { playlistLoading: true });
        case actionTypes.YOUTUBE_PLAYLIST_LIST_SUCCESS:
            const playlists = (action.reset && state.playlists) || {};
            if(action.result.items) {
                action.result.items.forEach(item => {
                    /*if(!playlists[item.snippet.channelId]) {
                        playlists[item.snippet.channelId] = {};
                    }
                    playlists[item.snippet.channelId][item.id] = item;*/
                    playlists[item.id] = item;
                });
            } 
            return updateObject(state, { playlistResult: action.result, playlists: playlists, playlistLoading: false });
        case actionTypes.YOUTUBE_PLAYLIST_LIST_FAIL:
			return updateObject(state, { playlistLoading: false });
        case actionTypes.YOUTUBE_PLAYLIST_ITEMS_LIST_START:
			return updateObject(state, { playlistItemLoading: true });
         case actionTypes.YOUTUBE_PLAYLIST_ITEMS_LIST_SUCCESS:
            const items = {};
            if(action.result.items) {
                action.result.items.forEach(item => {
                    if(!items[item.snippet.playlistId]) {
                        items[item.snippet.playlistId] = {};
                    }
                    
                    items[item.snippet.playlistId][item.snippet.resourceId.videoId] = item;
                    /*if(!playlists[item.snippet.channelId]) {
                        playlists[item.snippet.channelId] = {};
                    }
                    playlists[item.snippet.channelId][item.id] = item;*/
                    //items[item.id] = item;
                });
            }
            return updateObject(state, { playlistItemResult: action.result, playlistsItems: items, playlistItemLoading: false });
        case actionTypes.YOUTUBE_PLAYLIST_ITEMS_LIST_FAIL:
			return updateObject(state, { playlistItemLoading: false });
        case actionTypes.YOUTUBE_VIDEO_LIST_START:
            return updateObject(state, { loading: true });
        case actionTypes.YOUTUBE_VIDEO_LIST_SUCCESS:
            const videos = {};
            const noSnippet = {};
            if(action.result.items) {
                action.result.items.forEach(item => {
					//console.log(item,item.id.videoId);
                    if(item.snippet) {
                        videos[item.id] = item;
                    } else {
                        noSnippet[item.id] = item;
                    }
                });
            } 
            return updateObject(state, { videoResult: action.result, videos: videos, loading: false, videosWithoutSnippet: noSnippet });
        case actionTypes.YOUTUBE_VIDEO_LIST_FAIL:
            return updateObject(state, { loading: false });
        default: 
            return state;
    }
}

export default reducer;
